// custom history object to allow navigation outside react components
export const history: any = {
	navigate: null,
	location: null,
};
